'use client';

import { Box, Container, Heading } from '@chakra-ui/react';

import { assetsUri } from '@/services/api.service';

import styles from './BannerSection.module.scss';

type Props = {
  props: {
    title: string;
    description: string;
    image: string;
    mobileImage: string;
    url: string;
  };
  showOverlay?: boolean;
};

const BannerSection = ({ props, showOverlay = true }: Props) => {
  const imageKeys = {
    desktopKey: 'promotions-banner-desktop',
    mobileKey: 'promotions-banner-mobile',
  };

  return (
    <Box className={styles.promotionBannerWrapper}>
      <Box className={styles.bannerSwiper}>
        <Box
          className={`${styles.bannerSwiperWrap} ${
            showOverlay ? styles.withOverlay : ''
          }`}
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection={{ base: 'column', lg: 'row' }}
          height={{ base: 'auto', lg: '450px' }}
        >
          <picture className={styles.bannerImage}>
            <source
              media="(max-width: 575px)"
              srcSet={`${assetsUri}/${props.mobileImage}?key=${imageKeys.mobileKey}`}
            />

            <source
              media="(min-width: 576px)"
              srcSet={`${assetsUri}/${props.image}?key=${imageKeys.desktopKey}`}
            />

            <img
              src={`${assetsUri}/${props.image}?key=${imageKeys.desktopKey}`}
              alt={props.title || 'banner-image'}
              title={props.title || 'banner-image'}
              width={1280}
              height={681}
              loading="eager"
              fetchPriority="high"
            />
          </picture>

          <Container
            className={styles.bannerContentWrapper}
            maxW="1280"
            width="100%"
            alignContent="center"
            zIndex={1}
            paddingX={{ base: 6 }}
            paddingY="0px"
            marginTop="auto"
          >
            <Box className={styles.bannerContent}>
              <Box
                className={styles.headingElement}
                textAlign="center"
              >
                <Heading
                  as="h1"
                  className={styles.titleLg}
                  color="white"
                  marginBottom={4}
                  marginTop={{
                    base: 8,
                    sm: 0,
                  }}
                >
                  {props.title}
                </Heading>

                {props.description && (
                  <Box
                    className={styles.visuallyHidden}
                    aria-hidden="false"
                    color="white"
                    mb={8}
                    dangerouslySetInnerHTML={{
                      __html: props.description,
                    }}
                  />
                )}
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default BannerSection;